module.exports = __webpack_public_path__ + "img/partner14.5246c2c0.png";